/**
 * No-op analytics surface. Wire to Amplitude (or whatever vendor) later.
 * Keep call sites stable so business logic doesn't change when we wire it.
 */

export interface AnalyticsUserTraits {
  email?: string | null;
  displayName?: string | null;
  [key: string]: unknown;
}

export const analytics = {
  pageView(_path: string): void {
    // intentionally empty
  },
  identify(_userId: string, _traits?: AnalyticsUserTraits): void {
    // intentionally empty
  },
  reset(): void {
    // intentionally empty
  },
  track(_event: string, _properties?: Record<string, unknown>): void {
    // intentionally empty
  },
};
